function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M55.5 41.159V80H45V41.086l-6.641 1.21a2 2 0 0 1-2.005-3.102l12.94-18.762a1 1 0 0 1 1.646 0l12.948 18.774a2 2 0 0 1-2 3.104z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/directions/ic-continue-straight.svg";
export { SvgComponent as ReactComponent };